<ng-container *ngIf="isLoggedIn">
  <app-token></app-token>
  <app-header></app-header>
</ng-container>

<router-outlet></router-outlet>

<app-footer></app-footer>
